export default __webpack_public_path__ + "static/media/handshake.1435559f.gif";